// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__daS-a","col":"styles_col__3FtGN"};